import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectModule } from '../selectors/module.selector';
import { moduleActions } from '../actions/module.actions';
import { ModuleValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ModuleFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly module$ = this.store.select(selectModule);
    readonly moduleNonNullable$ = this.store.select(selectModule).pipe(filter((module) => module !== null));

    readonly module = this.store.selectSignal(selectModule);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getModule(id: string): void {
        this.store.dispatch(moduleActions.getModule({ id }));
    }

    createModule(value: ModuleValue): void {
        this.store.dispatch(moduleActions.createModule({ value }));
    }

    updateModule(id: string, value: ModuleValue): void {
        this.store.dispatch(moduleActions.updateModule({ id, value }));
    }

    deleteModule(id: string): void {
        this.store.dispatch(moduleActions.deleteModule({ id }));
    }

    clear(): void {
        this.store.dispatch(moduleActions.clear());
    }
}
